import { Component,Input, OnInit } from '@angular/core';
import { CartService } from 'src/app/shared/services/cart.service';
import { CompareService } from 'src/app/shared/services/compare.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { WishlistService } from 'src/app/shared/services/wishlist.service';
//import { IProduct } from 'src/app/shared/types/product-d-t';

@Component({
  selector: 'app-product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.scss']
})
export class ProductItemComponent implements OnInit{
  @Input() product: any;

  constructor(
    public cartService: CartService,
    public wishlistService: WishlistService,
    public compareService: CompareService,
    public utilsService: UtilsService,
  ) {

  }

  ngOnInit() {
    console.log(this.product);
  }

  // add to cart
  addToCart(item: any) {
    this.cartService.addCartProduct(item);
  }

   // add to cart
   addToWishlist(product: any) {
    this.wishlistService.add_wishlist_product(product);
  }

  // add to cart
  addToCompare(product: any) {
    this.compareService.add_compare_product(product);
  }

  // Function to check if an item is in the cart
  isItemInCart(item: any): boolean {
    return this.cartService.getCartProducts().some((prd: any) => prd.id === item.id);
  }
  isItemInWishlist(item: any): boolean {
    return this.wishlistService.getWishlistProducts().some((prd: any) => prd.id === item.id);
  }
  isItemInCompare(item: any): boolean {
    return this.compareService.getCompareProducts().some((prd: any) => prd.id === item.id);
  }

}
